"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const moment_1 = __importDefault(require("moment"));
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
function default_1({ roomId, cart, isDemandSurvey, customDeliveryId, refetchProductData, confirm, }) {
    const verifyAmount = () => {
        let invalidAmount = false;
        cart.forEach(item => {
            if (item.amount <= 0) {
                invalidAmount = true;
                return false;
            }
        });
        return invalidAmount;
    };
    const verifyPurchaseLimit = () => {
        let overLimit = false;
        cart.forEach(item => {
            if (item.amount > item.purchase_limit) {
                overLimit = true;
                return false;
            }
        });
        return overLimit;
    };
    const generateError = () => {
        if (!cart.length)
            return i18next_1.default.t('메뉴를 선택해주세요.');
        else if (verifyAmount())
            return i18next_1.default.t('메뉴 개수를 확인 후 다시 시도해주세요.');
        else if (verifyPurchaseLimit())
            return i18next_1.default.t('1인당 구매개수를 초과했어요');
        else
            return false;
    };
    const refreshUnknownError = () => {
        const reloadPage = () => window.location.reload();
        confirm({
            description: `${i18next_1.default.t('앗, 인터넷 연결이 불안정해요!')} ${i18next_1.default.t('연결 확인 후 새로고침해주세요')}:)`,
            cancellationButtonProps: { style: { display: 'none' } },
        })
            .then(reloadPage)
            .catch(reloadPage);
    };
    const checkOrderStatus = (trid) => {
        var _a;
        const price = (_a = document.getElementById('order_total')) === null || _a === void 0 ? void 0 : _a.innerText;
        setTimeout(() => {
            (0, api_1.getData)(`/api/v1/fonrympic/room/${roomId}/order/${trid}`)
                .then(res => {
                var _a, _b;
                const orderStatus = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.order_status;
                if (orderStatus === 'Pending') {
                    checkOrderStatus(trid);
                }
                else if (orderStatus === 'Ordered') {
                    const { order_id, order_reg, deliveryId } = res.data.result;
                    const formattedOrderReg = order_reg.slice(0, 16).replace('T', ' ');
                    window.location.href = isDemandSurvey
                        ? `/order/demand-detail-view/${order_id}`
                        : `/credit/charge_success?` +
                            `roomId=${roomId}` +
                            `&price=${price}` +
                            `&order_id=${order_id}` +
                            `&order_status=ready` +
                            `&order_reg=${formattedOrderReg}` +
                            `&deliveryId=${deliveryId}` +
                            `${customDeliveryId ? '&customDeliveryId=' + customDeliveryId : ''}`;
                }
            })
                .catch(refreshUnknownError);
        }, 500);
    };
    const [orderPending, setOrderPending] = (0, react_1.useState)(false);
    const submitOrder = () => __awaiter(this, void 0, void 0, function* () {
        (0, functions_1.tempDisableClick)(500);
        const error = generateError();
        if (error)
            (0, functions_1.showToastMessage)({ message: error });
        else if (orderPending)
            return;
        else {
            setOrderPending(true);
            const orderData = {};
            const cartData = cart.map(item => ({
                id: item.id,
                amount: item.amount,
            }));
            Object.assign(orderData, { orders: cartData });
            if (customDeliveryId)
                Object.assign(orderData, { room_delivery_id: customDeliveryId });
            yield (0, api_1.postData)(`/api/v1/fonrympic/room/${roomId}/after-pay`, orderData)
                .then(res => checkOrderStatus(res.data.meta.trid))
                .catch(err => {
                var _a, _b;
                const statusCode = err.response.status;
                const currentLocation = `${window.location.pathname}?room_id=${roomId}`;
                const cartParam = `&cart=${JSON.stringify(cartData)}`;
                const customParam = customDeliveryId ? `&custom=${customDeliveryId}` : '';
                const refreshLocation = currentLocation + cartParam + customParam;
                if (statusCode === 400) {
                    // ? empty session
                    window.location.href = `/login/?next_page=${refreshLocation}`;
                }
                else if (statusCode === 403 || statusCode === 412) {
                    const alertType = Number((_b = (_a = err.response.data) === null || _a === void 0 ? void 0 : _a.meta) === null || _b === void 0 ? void 0 : _b.alert_type);
                    if (alertType === 41201) {
                        // ? sold out
                        (0, functions_1.showToastMessage)({ message: i18next_1.default.t('선택한 메뉴가 품절되었습니다.') });
                        refetchProductData();
                    }
                    else if (alertType === 41202 || alertType === 40301) {
                        // ? no order time || end order time
                        window.location.replace(refreshLocation + '&change=t');
                    }
                    else {
                        const yymmdd = (0, moment_1.default)().format('YYMMDD');
                        confirm({
                            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('화면을 캡쳐하여 1:1 문의하기 해주세요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('접수 번호')}: ${yymmdd}${alertType}`] })),
                            confirmationText: i18next_1.default.t('1:1 문의하기'),
                        })
                            .then(() => (window.location.href = '/fondee/qna'))
                            .catch(() => { });
                    }
                }
                else {
                    refreshUnknownError();
                }
                setOrderPending(false);
            });
        }
    });
    return { orderPending, submitOrder };
}
exports.default = default_1;
